import { createSelector } from "reselect"
import { filter, get, size, keyBy, first } from "lodash"
import { getMustAggregateFactors, getRawSelectedViews, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { computeFactorsMetadata, computeSelectedViews, computeSelectedViewsFactors, mergeCategories } from "helpers/factors"
import { aggregateFactors } from "helpers/factorClassification"
import { getModelCategories, getModelFactors, getModelTopFactors, getModelFactorsClassification } from "selectors/modelMetadata"

const getIsStyleFactorsAdditive = (_, props) => get(props, "isStyleFactorsAdditive", true)

export const getFilterableCategories = createSelector(
  [getModelCategories],
  (categories) => filter(categories, cat => !cat.singleFactor),
)

const getFactorsAggregationOptions = createSelector(
  [getIsStyleFactorsAdditive, getStyleExposureAggregation],
  (isStyleFactorsAdditive, styleAggregation) => ({ isStyleFactorsAdditive, styleAggregation }),
)

export const getSelectViewAggregatedFactorsMetadata = createSelector(
  [getModelFactors, getMustAggregateFactors, getModelFactorsClassification],
  (rawFactors, mustAggregateFactors, factorsClassification) => {
    if (!mustAggregateFactors) {
      return rawFactors
    }

    // Force factors aggregation, custom views are always shown at the aggregated level.
    const factors = aggregateFactors(factorsClassification, rawFactors, null, { isStyleFactorsAdditive: true })
    return keyBy(factors, "id")
  },
)

export const getSelectedViews = createSelector(
  [getRawSelectedViews, getSelectViewAggregatedFactorsMetadata, getMustAggregateFactors],
  computeSelectedViews,
)

export const getSelectedViewsFactors = createSelector(
  [getSelectedViews, getModelFactors, getModelFactorsClassification],
  computeSelectedViewsFactors,
)

export const getFactorsMetadata = createSelector(
  [getModelFactors, getModelFactorsClassification, getSelectedViewsFactors, getFactorsAggregationOptions],
  computeFactorsMetadata,
)

export const getCategories = createSelector(
  [getModelCategories, getSelectedViews],
  mergeCategories,
)

export const getDisplayAddView = createSelector(
  [getMustAggregateFactors, getSelectedViews],
  (mustAggregateFactors, selectedViews) => mustAggregateFactors && size(selectedViews) < 10,
)

export const getTopFactor = createSelector(
  [getModelTopFactors],
  first,
)
